import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, shareReplay } from 'rxjs/operators'

import { CookieService } from 'ngx-cookie-service'
import type { Observable } from 'rxjs'
import type { User } from '@core/helper/fake-backend'
import { environment } from '@environment/environment'
import { StorageService } from './storage.service'

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User | null = null
  public readonly authSessionKey = '_OSEN_AUTH_SESSION_KEY_'
  private isAuthenticated = false;
  baseUrl = environment.baseUrl
  userProfile$!: Observable<any>;
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private storage: StorageService
  ) {
    this.isAuthenticated = !!this.storage.get("auth");
  }

  login(username: string, password: string, rememberMe=false): Observable<User> {
    return this.http.post(`${this.baseUrl}api/auth/login`, { username, password })
  }

  logout(): void {
    this.removeSession()
    this.user = null
  }

  isAuthenticatedUser(): boolean {
    return this.isAuthenticated;
  }


  get session(): string {
    return this.cookieService.get(this.authSessionKey)
  }

  saveSession(token: string): void {
    this.cookieService.set(this.authSessionKey, token)
  }

  removeSession(): void {
    this.cookieService.delete(this.authSessionKey)
  }
  getUserData(): Observable<any> {
      this.userProfile$ = this.http.get<any>(`${this.baseUrl}api/auth/user-profile`).pipe(
        shareReplay(1) // Caches the latest API response
      );
    return this.userProfile$;
  }
  // getUserData(): Observable<any> {
  //   if (!this.userProfile$) {
  //     this.userProfile$ = this.http.get<any>(`${this.baseUrl}api/auth/user-profile`).pipe(
  //       shareReplay(1) // Caches the latest API response
  //     );
  //   }
  //   return this.userProfile$;
  // }
}
